import { addToCartSimplifiedObject } from '~~/helpers/cart/cartActions';

import { isTestProduct } from '~~/helpers/product/isTestProduct';

type UseAddToCartQuantityParams = {
  sku: string;
  slug: string;
  fullProductPrice: number;
  productName: string;
  productImage: string;
  isMainProduct: boolean;
  addToCartText: string;
};

type AddToCartParams = {
  shouldOpenCart?: boolean;
}

type AddToCartFunction = (quantity: number, params?: AddToCartParams) => void

type UseAddToCartQuantityReturn = {
  addQuantity: AddToCartFunction;
};

export const useAddToCartQuantity = ({
  sku,
  slug,
  fullProductPrice,
  productName,
  productImage,
  isMainProduct,
  addToCartText,
}: UseAddToCartQuantityParams): UseAddToCartQuantityReturn => {

  const { setExtraGuaranteeInfo } = useExtraGuarantee();
  const { addToCart } = useAddToCart(slug, sku);
  const { getAddToCartButtonLocation } = useRouteOfAddToCart();
  const { triggerTags } = useAddToCartTagManager({
    slug,
    addToCartText,
  });
  const testProduct = computed(() => isTestProduct(sku));
  const addQuantity: AddToCartFunction = async (quantity, { shouldOpenCart } = {}) => {

    if (testProduct.value) {

      return;

    }
    setExtraGuaranteeInfo({ fullProductPrice, name: productName, image: productImage, sku });
    const triggeredIn = getAddToCartButtonLocation({
      isMainProduct,
    });
    await addToCart(
      { product: addToCartSimplifiedObject(sku), quantity, triggeredIn, shouldOpenCart });
    triggerTags({
      quantity,
      triggeredIn,
      shouldOpenCart,
    });

  };

  return {
    addQuantity,
  };

};
